import Vue from 'vue'
import Vuex from 'vuex'
//import modules from './modules'

Vue.use(Vuex)

const store = new Vuex.Store({
  //modules,
  state: {
    webSiteInfo: {
      baseData: {},
      boardData: [],
    },
    board: {
      idx: 0,
      page: 0,
      work: '',
    },
    boardSecurity: {
      work: '',
      password: '',
    },
    auth: {
      idx: 0,
      access_token: "",
      nick: "",
      level: 0,
      is_login: false,
      email: "",
    },
    modal: {
      _2xl: {
        val: '',
        worker: '',
      },
      _xl: {
        val: '',
        worker: '',
      },
      _lg: {
        val: '',
        worker: '',
      },
      _md: {
        val: '',
        worker: '',
      },
      _sm: {
        val: '',
        worker: '',
      },
    },
  },
  // state 불러올때는 getters에서 정의
  getters: {
    // 게시판 수정한다고 알려야됨
    getBoardSecurity(state) {
      return state.boardSecurity
    },
    // 게시판 현재 게시판번호와 현재 페이지
    getNowBoard(state) {
      return state.board
    },
    // 웹사이트기본설정
    getWebSiteInfoBase(state) {
      return state.webSiteInfo.baseData
    },
    // 게시판기본설정
    getWebSiteInfoBoard(state) {
      return state.webSiteInfo.boardData
    },
    // 로그인관련
    getAuthIdx(state) {
      return state.auth.idx
    },
    getAuthAccessToken(state) {
      return state.auth.access_token
    },
    getAuthNick(state) {
      return state.auth.nick
    },
    getAuthLevel(state) {
      return state.auth.level
    },
    getAuthIsLogin(state) {
      return state.auth.is_login
    },
    getAuthEmail(state) {
      return state.auth.email
    },
    // 모달 - worker 체크
    getModal_2xl(state) {
      return state.modal._2xl;
    },
    getModal_xl(state) {
      return state.modal._xl;
    },
    getModal_lg(state) {
      return state.modal._lg;
    },
    getModal_md(state) {
      return state.modal._md;
    },
    getModal_sm(state) {
      return state.modal._sm;
    },
  },
  // state변경할때는 mutations에서 정의
  mutations: {
    // 게시판수정한다고 선언
    setBoardSecurity(state, value) {
      state.boardSecurity = value
    },
    // 게시판 현재 게시판번호와 페이지번호
    setNowBoard(state, value) {
      state.board = value
    },
    // 웹사이트기본설정
    setWebSiteInfoBase(state, value) {
      state.webSiteInfo.baseData = value;
    },
    // 게시판기본설정
    setWebSiteInfoBoard(state, value) {
      state.webSiteInfo.boardData = value;
    },
    // 로그인관련
    setAuthIdx(state, value) {
      state.auth.idx = value;
    },
    setAuthAccessToken(state, value) {
      state.auth.access_token = value;
    },
    setAuthNick(state, value) {
      state.auth.nick = value;
    },
    setAuthLevel(state, value) {
      state.auth.level = value;
    },
    setAuthIsLogin(state, value) {
      state.auth.is_login = value;
    },
    setAuthEmail(state, value) {
      state.auth.email = value;
    },
    // 모달 set
    setModal_2xlWorker(state, value) {
      state.modal._2xl.worker = value;
    },
    setModal_2xlVal(state, value) {
      state.modal._2xl.val = value;
    },
    setModal_xlWorker(state, value) {
      state.modal._xl.worker = value;
    },
    setModal_xlVal(state, value) {
      state.modal._xl.val = value;
    },
    setModal_lgWorker(state, value) {
      state.modal._lg.worker = value;
    },
    setModal_lgVal(state, value) {
      state.modal._lg.val = value;
    },
    setModal_mdWorker(state, value) {
      state.modal._md.worker = value;
    },
    setModal_mdVal(state, value) {
      state.modal._md.val = value;
    },
    setModal_smWorker(state, value) {
      state.modal._sm.worker = value;
    },
    setModal_smVal(state, value) {
      state.modal._sm.val = value;
    },
  },
  //strict: process.env.NODE_ENV !== 'production',
})

export default store
